import { render, staticRenderFns } from "./practitioner.vue?vue&type=template&id=06f9c391&scoped=true&"
import script from "./practitioner.vue?vue&type=script&lang=js&"
export * from "./practitioner.vue?vue&type=script&lang=js&"
import style0 from "./practitioner.vue?vue&type=style&index=0&id=06f9c391&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f9c391",
  null
  
)

export default component.exports